import { useState, useEffect } from 'react';

/**
 * Hook to manage call duration with automatic updates every second.
 *
 * @param startTime - ISO string of when the call started
 * @param initialDuration - Initial duration in seconds (fallback)
 * @returns Current duration in seconds, updated every second
 */
export function useCallDuration(
  startTime: string | null | undefined,
  initialDuration: number
): number {
  const [duration, setDuration] = useState(initialDuration);

  useEffect(() => {
    if (!startTime) return;

    const updateDuration = () => {
      const start = new Date(startTime).getTime();
      const now = Date.now();
      const newDuration = Math.floor((now - start) / 1000);
      setDuration(newDuration);
    };

    // Update immediately
    updateDuration();

    // Then update every second
    const interval = setInterval(updateDuration, 1000);

    return () => clearInterval(interval);
  }, [startTime]);

  return duration;
}
